import { Authenticator } from "@aws-amplify/ui-react";
import { Routes, Route, NavLink, Navigate, useLocation } from "react-router-dom";

import FloatingChat from "./components/FloatingChat";
import Agents from "./pages/Agents";
import Chat from "./pages/Chat";
import Dashboard from "./pages/Dashboard";
import ListingDetail from "./pages/ListingDetail";
import MapView from "./pages/MapView";
import SoldComps from "./pages/SoldComps";
import Settings from "./pages/Settings";
import Visits from "./pages/Visits";

function Nav({ signOut, email }: { signOut: () => void; email?: string }) {
  const link = (to: string, label: string) => (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        padding: "8px 12px",
        borderRadius: 6,
        background: isActive ? "var(--panel)" : "transparent",
        color: isActive ? "var(--text)" : "var(--muted)",
      })}
    >
      {label}
    </NavLink>
  );
  return (
    <nav
      style={{
        display: "flex",
        gap: 8,
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid var(--border)",
        background: "var(--bg)",
        position: "sticky",
        top: 0,
        zIndex: 5,
      }}
    >
      <strong style={{ marginRight: 12 }}>Market Analyzer</strong>
      {link("/", "Listings")}
      {link("/insights", "Insights")}
      {link("/sold-comps", "Sold Comps")}
      {link("/visits", "Visits")}
      {link("/agents", "Agents")}
      {link("/settings", "Settings")}
      <span style={{ flex: 1 }} />
      {email && <span className="muted">{email}</span>}
      <button onClick={signOut}>Sign out</button>
    </nav>
  );
}

function MainShell() {
  const location = useLocation();
  // The combined listings + map (the home page) wants full-bleed; other
  // pages stay constrained for readability.
  const fullWidth = location.pathname === "/";
  return (
    <main
      style={{
        maxWidth: fullWidth ? "none" : 1200,
        margin: "0 auto",
        padding: fullWidth ? "16px 20px" : "20px 16px",
      }}
    >
      <Routes>
        <Route path="/" element={<MapView />} />
        <Route path="/insights" element={<Dashboard />} />
        <Route path="/listings/:listingId" element={<ListingDetail />} />
        <Route path="/listings" element={<Navigate to="/" replace />} />
        <Route path="/sold-comps" element={<SoldComps />} />
        <Route path="/visits" element={<Visits />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </main>
  );
}

export default function App() {
  return (
    <Authenticator hideSignUp>
      {({ signOut, user }) => (
        <>
          <Nav signOut={signOut!} email={user?.signInDetails?.loginId} />
          <MainShell />
          <FloatingChat />
        </>
      )}
    </Authenticator>
  );
}
